<template>
  <div>
    <front-page-top-navigation-secondary />
    <home-slider-secondary />
    <div class="bg-white">
      <tw-container>
        <div class="max-w-[900px] mx-auto">
          <img src="/img/frontpage-banner.png">
          <h2 class="text-4xl font-light">
            We're Helping Raise Millions for Good
          </h2>
          <p class="pt-4 font-sans font-semibold">
            GroupRev is the choice of amazing organizations everywhere for customizable peer to peer fundraising
          </p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Group Fundraising has <span class="text-amber-500">Never Been Easier.</span>
            </h2>
            <p>
              GroupRev makes group fundraising simple and effective for nonprofits, churches, mission teams, schools, and community groups. Create beautiful peer to peer and team fundraising pages in minutes with no
              technical skills needed. Supporters share their stories with custom photos and videos, donors give securely, and you track everything in one clean dashboard.
            </p>
            <p>With zero platform fees and powerful fundraising tools, GroupRev helps you raise more for the causes that matter most.</p>
          </div>
          <div>
            <img src="/img/frontpage-banner-hands.png" alt="Hands holding a heart">
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div>
            <img src="/img/frontpage-banner-credit-card-generic.png" alt="Fundraising raised amount">
          </div>
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              It's Like Your Own <span class="text-amber-500">White Labeled Peer to Peer Fundraising Platform</span>
            </h2>
            <p>
              GroupRev gives your organization a fully branded and white labeled peer to peer fundraising platform without the complexity or cost of enterprise fundraising software. Every campaign, team page, and
              personal fundraiser reflects your mission and your brand. Create unlimited fundraisers, empower supporters to raise money through personalized pages, and manage it all from one simple dashboard for a
              professional and inspiring fundraising experience.
            </p>
          </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Personalized <span class="text-amber-500">Peer to Peer Fundraising Pages</span>
            </h2>
            <p>
              GroupRev lets every participant create a personal fundraising page that feels truly their own. Supporters can upload photos, videos, and meaningful stories that inspire friends and family to give. With
              simple editing tools and flexible layouts, each page becomes an authentic expression of why the cause matters and helps drive higher engagement and stronger peer to peer fundraising results.
            </p>
          </div>
          <div>
            <img src="/img/frontpage-banner-hands.png" alt="Hands holding a heart">
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div>
            <img src="/img/frontpage-banner-credit-card-generic.png" alt="Fundraising raised amount">
          </div>
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Total Control for Every <span class="text-amber-500">Fundraising Campaign</span>
            </h2>
            <p>
              GroupRev gives you complete control over how your group or peer to peer fundraising campaign is structured. Set team goals, individual goals, and deadlines or let participants choose their own. Approve who
              can join and customize permissions to match your needs. Whether you are running a mission trip fundraiser, a church campaign, a school fundraiser, or a nonprofit peer to peer event, GroupRev gives you the
              flexibility to fundraise exactly the way you want.
            </p>
          </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Powerful <span class="text-amber-500"> Fundraising Communication Tools</span>
            </h2>
            <p>
              GroupRev includes built-in fundraising communication tools that help supporters reach more donors with less effort. Participants can send fundraising emails directly from GroupRev, and our automated drip
              campaigns do the follow up for them. The system tracks who donates and automatically removes donors from the email sequence so supporters never spam their friends or send unnecessary messages. This smart
              automation helps every fundraiser raise more with simple, targeted communication.
            </p>
          </div>
          <div>
            <img src="/img/frontpage-banner-hands.png" alt="Hands holding a heart">
          </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div>
            <img src="/img/frontpage-banner-credit-card-generic.png" alt="Fundraising raised amount">
          </div>
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Real-Time Progress and <span class="text-amber-500">Fundraising Dashboards</span>
            </h2>
            <p>
              GroupRev gives every participant and team access to real-time fundraising dashboards that make it easy to track progress and stay motivated. Fundraisers can see how much they have raised, how much time is
              left, and how close they are to reaching their goal. They receive email notifications for every donation and can review detailed updates at any time. With clear reporting and instant insights, GroupRev
              helps every fundraiser stay engaged and inspired to reach their goals.
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Zero Platform Fees and <span class="text-amber-500"> the Lowest Cost in Fundraising</span>
            </h2>
            <p>
              GroupRev is completely free for organizations. You never pay a platform fee, a subscription, or a monthly charge. Donations are processed at the industry standard rate of 2.9% plus 30 cents, and a small
              optional donor tip supports the platform. Unlike GoFundMe and others that push 15 to 20 percent tips, ours is small, capped, and always optional. This transparent pricing model keeps more money going
              directly to your mission, your team, and your cause.
            </p>
          </div>
          <div>
            <img src="/img/frontpage-banner-hands.png" alt="Hands holding a heart">
          </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div>
            <img src="/img/frontpage-banner-credit-card-generic.png" alt="Fundraising raised amount">
          </div>
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Built for <span class="text-amber-500">Nonprofits, Causes, Mission Trips, Churches, Schools, and Teams</span>
            </h2>
            <p>
              GroupRev is designed for nonprofits and meaningful causes that need a simple and effective way to fundraise online. Whether you are running a nonprofit peer to peer campaign, coordinating a mission trip
              fundraiser, launching a church or ministry giving effort, organizing a school fundraiser, or raising support for a team or community project, GroupRev gives you the tools to succeed.
            </p>
          </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              Millions Raised for <span class="text-amber-500"> Nonprofits and Causes</span>
            </h2>
            <p>
              Organizations across the country use GroupRev to raise millions of dollars for nonprofits, mission teams, churches, schools, and community causes. Our peer to peer fundraising platform makes it easy to
              launch successful campaigns with personalized pages, team tools, and fast, secure donations.
            </p>
            <p>Here are some of the most common ways groups use GroupRev to raise more.</p>
            <ul>
              <li>Nonprofit peer to peer fundraising</li>
              <li>Fundraising for causes and service projects</li>
              <li>Mission trip fundraising</li>
              <li>Church and ministry fundraising</li>
              <li>School and student trip fundraising</li>
              <li>Youth group and team fundraising</li>
              <li>Group crowdfunding for community needs</li>
            </ul>
          </div>
          <div>
            <img src="/img/frontpage-banner-hands.png" alt="Hands holding a heart">
          </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 mt-10">
          <div>
            <img src="/img/frontpage-banner-credit-card-generic.png" alt="Fundraising raised amount">
          </div>
          <div class="flex flex-col gap-4">
            <h2 class="text-4xl font-light">
              The Lowest Cost <span class="text-amber-500">Fundraising Platform</span>
            </h2>
            <p>
              GroupRev is the best fundraising alternative for groups, teams, nonprofits, churches, schools, and mission trips. Unlike GoFundMe and GiveSendGo, which focus on personal crowdfunding and push high donor
              tips, GroupRev offers true peer to peer fundraising with powerful team tools, unmatched customization, and transparent, low-cost pricing.
            </p>
            <p>
              Compared to Givebutter and Classy, GroupRev gives you a fully branded, flexible fundraising platform without subscriptions, contracts, or complicated feature tiers. It is the most affordable and
              customizable option for any group or organization that wants to raise more with real support and fair pricing.
            </p>
          </div>
        </div>

        <h2 class="text-center text-4xl font-light mt-20 mb-10">
          GroupRev is the #1 Peer to Peer Fundraising Platform for Groups and Teams
        </h2>

        <div class="grid grid-cols-3 gap-2">
          <tw-card class="flex flex-col gap-4 border-2 border-gray-100">
            <div>
              <font-awesome-icon :icon="['regular','folder']" class="text-amber-500 bg-amber-50 p-5" size="2x" />
            </div>
            <div class="text-2xl">
              Create Stunning Fundraiser Pages
            </div>
            <p>Create a customize peer to peer fundraising page that matches your organization and brand.</p>
          </tw-card>
          <tw-card class="flex flex-col gap-4 border-2 border-gray-100">
            <div>
              <font-awesome-icon icon="users" class="text-green-500 bg-green-50 p-5" size="2x" />
            </div>
            <div class="text-2xl">
              Personalized Fundraising Pages for Groups
            </div>
            <p>Teams and groups can create personalized fundraising pages attached to your campaign with personalized text, images, and videos..</p>
          </tw-card>
          <tw-card class="flex flex-col gap-4 border-2 border-gray-100">
            <div>
              <font-awesome-icon icon="user-clock" class="text-amber-500 bg-amber-50 p-5" size="2x" />
            </div>
            <div class="text-2xl">
              Track Campaign Progress in Real Time
            </div>
            <p>Monitor raised amounts, percentage completion, and time remaining with built‑in progress indicators.</p>
          </tw-card>
          <tw-card class="flex flex-col gap-4 border-2 border-gray-100">
            <div>
              <font-awesome-icon icon="bullhorn" class="text-green-500 bg-green-50 p-5" size="2x" />
            </div>
            <div class="text-2xl">
              Reach More Donors with Powerful Marketing Tools
            </div>
            <p>Share your peer to peer fundraising campaign with integrated email tools, QR codes, social media integration and more..</p>
          </tw-card>
          <tw-card class="flex flex-col gap-4 border-2 border-gray-100">
            <div>
              <font-awesome-icon :icon="['regular','building']" class="text-amber-500 bg-amber-50 p-5" size="2x" />
            </div>
            <div class="text-2xl">
              Display Leaderboards and Group Members
            </div>
            <p>Keep track of the fundraising progress of your group members and team with public stats, progress meters, and leaderboards.</p>
          </tw-card>
          <tw-card class="flex flex-col gap-4 border-2 border-gray-100">
            <div>
              <font-awesome-icon icon="bank" class="text-green-500 bg-green-50 p-5" size="2x" />
            </div>
            <div class="text-2xl">
              Fast Direct Deposit Payouts of Your Donations
            </div>
            <p>Accept credit card donations including Apple Pay quickly and easily. All your donations are paid quickly with direct deposit payouts.</p>
          </tw-card>
        </div>


        <div class="flex justify-center mt-20 mb-10">
          <tw-button size="lg" class="py-5 px-10" variant="amber" @click="$refs.organizationRegisterIntegratedModal.open()">
            Get Started
          </tw-button>
        </div>
        <organization-register-integrated-modal ref="organizationRegisterIntegratedModal" />

        <div class="grid grid-cols-2 gap-10">
          <div class="bg-[url('/img/login-form-backg.jpg')] p-24 rounded-xl m-10">
            <login-form no-labels class="bg-white p-10">
              <template #above>
                <div class="flex justify-center mb-10">
                  <img src="/img/login-grouprev.png">
                </div>
              </template>
            </login-form>
          </div>
          <div>
            <h1>How it works</h1>
            <h2>Launching Your Fundraising Page in Minutes!</h2>
            <home-page-how-it-works />
          </div>
        </div>
      </tw-container>
    </div>
    <div class="bg-gray-100 py-10 md:py-20">
      <tw-container-full-width class="flex flex-col gap-14 md:gap-20 max-w-[1360px]">
        <trending-fundraisers />
        <top-fundraiser-pages />
      </tw-container-full-width>
    </div>
    <div class="py-4 w-full">
      <grouprev-public-footer />
    </div>
  </div>
</template>

<script>
import HomeSlider from '@/pages/home/home-slider.vue'
import TwContainerFullWidth from '../components/generic/tw-container-full-width.vue'
import FrontPageTopNavigation from '@/components/FrontPageTopNavigation.vue'
import TopFundraiserPages from '@/pages/home/top-fundraiser-pages.vue'
import TrendingFundraisers from '@/pages/home/trending-fundraisers.vue'
import GrouprevPublicFooter from '@/components/grouprev-public-footer.vue'
import FrontPageTopNavigationSecondary from '../components/FrontPageTopNavigationSecondary.vue'
import HomeSliderSecondary from './home/home-slider-secondary.vue'
import TwGridDual from '../components/generic/tw-grid-dual.vue'
import TwContainer from '../components/generic/tw-container.vue'
import TwCard from '../components/generic/tw-card.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import TwButton from '../components/generic/tw-button.vue'
import OrganizationRegisterIntegratedModal from '../components/organizations/organization-register-integrated-modal.vue'
import LoginForm from '../components/auth/login-form.vue'
import HomePageHowItWorks from '../components/home/home-page-how-it-works.vue'

export default {
  name: 'HomePage',
  components: {
    HomePageHowItWorks,
    LoginForm,
    OrganizationRegisterIntegratedModal,
    TwButton,
    FontAwesomeIcon,
    TwCard,
    TwContainer,
    TwGridDual,
    HomeSliderSecondary,
    FrontPageTopNavigationSecondary,
    GrouprevPublicFooter,
    TrendingFundraisers,
    TopFundraiserPages,
    FrontPageTopNavigation,
    TwContainerFullWidth,
    HomeSlider
  }
}
</script>
